import { render, staticRenderFns } from "./leifeng-activity.vue?vue&type=template&id=74567ba2&scoped=true&"
import script from "./leifeng-activity.vue?vue&type=script&lang=js&"
export * from "./leifeng-activity.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-activity.vue?vue&type=style&index=0&id=74567ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74567ba2",
  null
  
)

export default component.exports